const VERSION_PATTERN = /^\d+(\.\d+)*$/;

export function parseVersion(version: unknown): number[] | null {
  if (typeof version !== 'string') {
    return null;
  }
  const trimmed = version.trim();
  if (!VERSION_PATTERN.test(trimmed)) {
    return null;
  }
  return trimmed.split('.').map(Number);
}

/**
 * True only when both versions parse and `current` is strictly lower. Anything unparseable
 * is treated as "not below" so a bad remote value or an odd native version never locks a
 * customer out of the app.
 */
export function isVersionBelow(current: unknown, minimum: unknown): boolean {
  const currentParts = parseVersion(current);
  const minimumParts = parseVersion(minimum);
  if (!currentParts || !minimumParts) {
    return false;
  }
  const length = Math.max(currentParts.length, minimumParts.length);
  for (let i = 0; i < length; i++) {
    const a = currentParts[i] ?? 0;
    const b = minimumParts[i] ?? 0;
    if (a !== b) {
      return a < b;
    }
  }
  return false;
}
